export const pushToDataLayer = (options: Record<string, string>): void => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(options);
};
